import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { getPlayerData } from "core-integration/src/store/player/reducers";
import { ThunkDispatch } from "core-integration/src/store";
import { setCode, clearCode } from "core-integration/src/store/leagues/thunks";

// AutoJoin component simply stores the code in local storage and redirects
// the user somewhere sensible.

const AutoJoin: React.FC = () => {
  const reduxDispatch = useDispatch<ThunkDispatch>();
  const navigate = useNavigate();
  const { code } = useParams();
  const player = useSelector(getPlayerData);

  useEffect(() => {
    if (code) {
      reduxDispatch(setCode(code));
    } else {
      reduxDispatch(clearCode());
    }
  });
  const next =
    player && player.entry ? "/my-team" : player ? "/squad-selection" : "/";

  // Need this to make sure LocationProvider is ready
  setTimeout(() => {
    return navigate(next, {
      replace: true,
    });
  }, 0);
  return <div />;
};

export default AutoJoin;
